import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { badgeCss } from '../text'
import { TableRow } from './legacy-grid-table-row'

export const tableRowDataTestID = 'legacy-grid-parent-row'
export const tdDataTestID = 'legacy-grid-parent-row-data'
export const childrenContainerTestID = 'legacy-grid-parent-row-container'

interface ParentRowProps {
  readonly name: string
  readonly rowClassName?: string
  readonly columnConfigLength: number
}

export function ParentRow({
  name,
  rowClassName,
  columnConfigLength
}: ParentRowProps) {
  return (
    <TableRow
      dataTestID={tableRowDataTestID}
      className={rowClassName}
      isFirstRow={false}
      isLastRow={true}
    >
      <td
        data-testid={tdDataTestID}
        colSpan={columnConfigLength}
        className={css`
          padding: 8px 15px;
        `}
      >
        <div
          data-testid={childrenContainerTestID}
          className={cx(
            badgeCss,
            css`
              color: ${theme.color.neutral100};
              font-weight: 400;
              font-size: 11px;
            `
          )}
        >
          {name}
        </div>
      </td>
    </TableRow>
  )
}
